import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-header-login',
  templateUrl: './content-header-login.component.html',
  styleUrls: ['./content-header-login.component.scss']
})
export class ContentHeaderLoginComponent implements OnInit {

  @Input('icon') icon:any;
  @Input('img') img:any;
  @Input('title') title:any;
  @Input('desc') desc:any;
  @Input('hideBreadcrumb') hideBreadcrumb:boolean = false;
  @Input('hasBgImage') hasBgImage:boolean = false;
  @Input('class') class:any;
  constructor() { }

  ngOnInit() {
  }

}
